{
    "api_keys": {
        "generate": "Generate API Key",
        "saved": "I've saved the API key",
        "copy": "Copy"
    },
    "add": "Add",
    "request": {
        "create": "New request",
        "edit": "Edit request",
        "save": "Save request",
        "submit": "Submit request",
        "delete": "Delete",
        "export": {
            "title": "Export",
            "submit": "Download"
        },
        "item": {
            "add": "Add item",
            "remove": "Remove item"
        },
        "pause": "Pause subscription",
        "unpause": "Resume subscription",
        "subscription_history": "Subscription history",
        "add_existing": "Add existing expense",
        "delete_all_items": "Delete all items",
        "sync": "Synchronize",
        "sync_now": "sync now.",
        "reset_status": "Reset status",
        "restore": "Restore",
        "link_fields": "Link fields",
        "unlink_fields": "Unlink fields",
        "generate_request": "Generate request",
        "show_datev_import_protocol": "DUO import protocol",
        "folder": {
            "add": "Add new request",
            "attach": "Attach request",
            "edit": "Edit folder",
            "delete": "Delete folder",
            "archive": "Archive folder",
            "unarchive": "Unarchive folder",
            "attach_expense": "Attach request to folder",
            "detach": "Detach from folder",
            "status": {
                "draft": {
                    "confirm": "Submit",
                    "reject": "Delete"
                },
                "invoice_pending": {
                    "confirm": "Approve",
                    "reject": "Reject"
                },
                "approved": {
                    "confirm": "Mark folder as reviewed",
                    "reject": "Reject"
                }
            }
        },
        "add_to_folder": "Add to trip folder",
        "attach_to_folder": "Attach to folder",
        "add_request_to_folder": "Add request to trip folder",
        "attach_discount": "Discount"
    },
    "purchase_request": {
        "create": "New purchase request",
        "edit": "Edit purchase request"
    },
    "inbox_invoice": {
        "delete": "Delete",
        "preview": "Preview",
        "move": "Move to",
        "assign": "Assign to",
        "unassign": "Unassign",
        "retry_ocr": "Retry OCR",
        "new_expense": "New expense",
        "attach": "Attach to selected expense",
        "search": "Search...",
        "inbox": "Inbox",
        "download": "Download",
        "attach_to_request": "Attach to request",
        "select_type": "Select type"
    },
    "invoice_request": {
        "create": "New invoice request",
        "create_for_po": "New invoice request for purchase order #{{ poNumber }}",
        "edit": "Edit invoice request"
    },
    "subscription_request": {
        "create": "New subscription request",
        "edit": "Edit subscription request"
    },
    "reimbursement_request": {
        "create": "New reimbursement request",
        "edit": "Edit reimbursement request"
    },
    "subscription": {
        "create": "Create subscription",
        "edit": "Edit subscription",
        "submit": "Submit subscription",
        "save": "Save subscription",
        "subscription_can_not_be_deleted": "This subscription cannot be deleted because at least one request has already been exported. Alternatively, you can pause the subscription."
    },
    "credit_card": {
        "create": "New card",
        "options": "Options"
    },
    "vendor": {
        "create": "New vendor",
        "edit": "Edit vendor",
        "save": "Save vendor",
        "submit": "Create new vendor",
        "set_rule": "Set rule",
        "icon_search": {
            "title": "Search vendor icon",
            "confirm": "Use this icon",
            "search": "Search icon"
        }
    },
    "cost_center": {
        "create": "New cost center 1",
        "edit": "Edit Cost center 1",
        "save": "Save Cost center 1",
        "submit": "Create new cost center 1",
        "add_budget": "Add alternative budget"
    },
    "cost_center_group": {
        "create": "New cost center group",
        "edit": "Edit cost center group",
        "save": "Save cost center group",
        "submit": "Create cost center group"
    },
    "employee": {
        "create": "New employee",
        "edit": "Edit employee",
        "save": "Save employee",
        "submit": "Create new employee",
        "add_limit": "Add limit",
        "invite": "Invite employee",
        "restore": "Restore",
        "add_email_alias": "Add email alias",
        "add_creditor_number_name": "Add creditor number for {{name}}",
        "add_creditor_number": "Add creditor number",
        "sync": "Synchronize"
    },
    "employee_absence": {
        "set_up": "Absence set up",
        "add_absence": "Add absence",
        "select_replacement_approver": "It's urgent, select alternative approver",
        "absence": "Absence",
        "tooltip": "Your absence will automatically be imported via the Personio integration.",
        "add_substitute": "Add substitute"
    },
    "user": {
        "create": "New user",
        "create_cta": "Create new user",
        "edit": "Edit user",
        "add_to_company": "Add to company"
    },
    "user_profile": {
        "edit": "Edit profile",
        "save": "Save"
    },
    "password": {
        "change": "Change password",
        "update": "Update password"
    },
    "limit": {
        "add": "Add limit",
        "remove": "Remove limit"
    },
    "bug_report": {
        "create": "New feedback",
        "submit": "Send feedback"
    },
    "tool_settings": {
        "edit": "Edit tool settings",
        "save": "Save"
    },
    "business_address": {
        "edit": "Edit business address",
        "save": "Save"
    },
    "company_settings": {
        "edit": "Edit company settings",
        "save": "Save",
        "add_new": "Add new company",
        "mileage_distance_buffer": "Mileage reimbursement: distance buffer"
    },
    "feature_settings": {
        "edit": "Edit feature settings"
    },
    "expense_account_settings": {
        "expense_accounts": "Expense accounts",
        "save": "Save",
        "edit": "Update"
    },
    "cost_center_2_settings": {
        "cost_center_2": "Cost centers 2",
        "save": "Save"
    },
    "company_profile": {
        "add": "Add to company",
        "delete": "Delete profile",
        "edit": "Edit profile",
        "restore": "Restore profile"
    },
    "create": "New",
    "clear_all": "Clear all",
    "export": "Export",
    "retrieve": "Retrieve",
    "bulk_export": "Bulk export",
    "edit": "Edit",
    "set": "Set",
    "login": "Login",
    "approve": "Approve",
    "reject": "Reject",
    "request_changes": "Request Changes",
    "set_new_password": "Set new password",
    "upload_new_image": "Upload new image",
    "send_reminder": "Send reminder",
    "follow_up": "Follow-up",
    "reminder": "Reminder",
    "cancel_request": "Cancel request",
    "upload_invoice": "Upload invoice(s)",
    "invoice": "Invoice(s)",
    "upload_contract": "Upload contract(s)",
    "add_invoice": "Add document",
    "add_purchase_order": "Add purchase order",
    "add_contract": "Add contract",
    "or_drop_files": "Or drop file to upload",
    "upload_delivery_note": "Upload delivery note",
    "add_delivery_note": "Add delivery note",
    "replace_delivery_note": "Replace delivery note",
    "upload_company_logo": "Upload company logo",
    "replace_company_logo": "Replace company logo",
    "upload_profile_picture": "Upload profile picture",
    "replace_profile_picture": "Replace profile picture",
    "save": "Save",
    "save_view": "Save view",
    "cancel_subscription_history": "Close",
    "cancel": "Cancel",
    "delete": "Delete",
    "send": "Send",
    "verify": "Verify",
    "reset_password": "Reset password",
    "change_password": "Create new password",
    "upload_invoice_and_delivery_note": "Upload invoice & delivery note",
    "mark_as_reviewed": "Mark as reviewed",
    "approve_vendor": "Approve vendor",
    "reject_vendor": "Reject vendor",
    "marked_as_paid": "Marked as paid",
    "payment_options": "Payment options",
    "payment": "Payment",
    "bulk_payment": "Bulk payment",
    "add_payment": "Add payment",
    "sepa_xml": "SEPA-XML",
    "download_sepa": "Download SEPA-XML",
    "download_non_sepa": "Download NON-SEPA-XML",
    "generate_sepa": "Generate SEPA-XML",
    "generate_non_sepa": "Generate NON-SEPA-XML",
    "download_pdf": "PDF",
    "download_csv": "CSV",
    "mark_as_paid": "Mark as paid",
    "upload_csv": "Upload CSV",
    "matching": {
        "bank": {
            "title": "Bank matching",
            "menu": "Via bank connection",
            "submit": "Fetch bank transactions"
        },
        "csv": {
            "title": "CSV matching",
            "menu": "Via CSV upload",
            "submit": "Submit"
        },
        "upload_csv": "Upload CSV",
        "title": "Matching",
        "submit": "Perform matching",
        "add_transactions": "Add transactions",
        "unmatch": "Unmatch",
        "match": "Match",
        "create": "Create",
        "cancel": "Cancel",
        "new_request": "New request data",
        "add_possible_match": {
            "title": "Add expense as possible match",
            "submit": "Add"
        },
        "show_all": "Show all",
        "hide_low_matches": "Hide unlikely",
        "hide_already_matched": "Hide already matched",
        "show_already_matched": "Show already matched",
        "include_archived_expenses": "Include archived requests",
        "hide_archived_expenses": "Hide archived requests"
    },
    "submit": "Submit",
    "banking": {
        "add_bank_account": "Add bank account",
        "search_bank": {
            "title": "Search a bank",
            "search": "Search"
        },
        "import": "Import",
        "update": {
            "save": "Save"
        },
        "pay_now": "Pay now",
        "pay_on_date": "Pay on (date)",
        "connect_more_interfaces": "Connect more interfaces",
        "schedule_payment": {
            "submit": "Schedule payment",
            "cancel": "Cancel"
        },
        "direct_payment": {
            "submit": "Confirm payment",
            "cancel": "Cancel"
        },
        "add_bank_connection": "Connect a bank account from the settings",
        "resolve_consent": "resolve now",
        "manage_accounts": "Manage accounts",
        "refresh_payment_status": "Refresh payment status",
        "force_payment_status_reset": "Force transaction status reset"
    },
    "force_expense_payment_reset": "Force expense payment reset",
    "expense_account": {
        "add": "Add expense account"
    },
    "cost_center_2": {
        "add": "Add cost center 2",
        "create": "New cost center 2",
        "submit": "Submit"
    },
    "change": "Change",
    "edit_plan": "Edit plan",
    "filter": "Filter",
    "apply_filter": "Apply filter",
    "cards": {
        "issue_card": "Issue card",
        "remove_card": "Remove card",
        "edit": {
            "submit": "Update card"
        },
        "update_pin": "Update finway PIN",
        "set_pin": "Set finway PIN",
        "pin_title": "Your finway PIN number",
        "pin_remember_message": "Please remember your finway PIN number and do not share it with anyone.",
        "or_retry": "or retry.",
        "activate_card": "Activate card",
        "enroll_now": "Enroll now",
        "report_stolen": "Report card as stolen",
        "report_lost": "Report card as lost",
        "weavr_terms_agree": "I have read and agree to the terms of Weavr.",
        "paynetics_terms_agree": "I have read and agree to the terms of Paynetics.",
        "finish_onboarding": "this onboarding",
        "finish_onboarding_mobile": "this onboarding process.",
        "show_transfers": "Show transfers",
        "hide_transfers": "Hide transfers",
        "update_phone_number": "Update phone number",
        "request_limit_change": "Request limit change",
        "limit_change_submit": "Submit",
        "unblock_pin": "Unblock PIN",
        "verify_email": "Verify email"
    },
    "filter_option": {
        "select_all": "Select all",
        "deselect_all": "Deselect all"
    },
    "close": "Close",
    "wallet": {
        "wallet_details": "Wallet details",
        "wallet": "Wallet",
        "withdrawal": "Withdraw money",
        "funding": "Wallet funding",
        "submit": "Withdraw money",
        "direct_funding": "Transfer via bank connection",
        "bank_transfer": "Bank transfer",
        "transfer_now": "Transfer now",
        "auth_factor": {
            "resolve_now": "resolve now"
        },
        "verification_of_payee": {
            "title": "Send payment",
            "confirm_payment": "Confirm payment",
            "enter_new_name": "Enter new name",
            "accept_suggested_name": "Accept suggested name"
        },
        "finish_setup": "Finish setup"
    },
    "passcode": {
        "update": "Update finway PIN",
        "recover": "Recover finway PIN"
    },
    "upload_offer": "Upload offer(s)",
    "add_offer": "Add offer",
    "next_step": "Next step",
    "finish": "Finish",
    "back": "Back",
    "tax_settings": {
        "taxes": "VAT"
    },
    "tax": {
        "add": "Add VAT"
    },
    "team_settings": {
        "teams": "Team settings"
    },
    "team": {
        "add": "Add a team"
    },
    "connect": "Connect",
    "continue": "Continue setup",
    "disconnect": "Disconnect",
    "datev_demo_mode": "DUO Demo",
    "datev_auto_export": "Auto-Export",
    "create_workflows": "Add a new workflow",
    "workflow": {
        "create": "New workflow",
        "edit": "Edit workflow",
        "next_step": "Next step"
    },
    "expense_split": {
        "save": "Save changes",
        "split": "Split invoice",
        "edit": "Edit",
        "reset": "Reset changes"
    },
    "period": "Period",
    "show": "Show",
    "chart_view": "Chart view",
    "detail_view": "Detail view",
    "budget_view": "Budget view",
    "reload": "Reload",
    "liquidity": {
        "add_scenario": "Add scenario",
        "edit_scenario": "Edit scenario",
        "delete_scenario": "Delete scenario",
        "plan_transactions": "Plan transactions",
        "add_bank_account": "Add bank account"
    },
    "troubleshooting": {
        "clear_cache_and_cookies": "Clear cache and cookies"
    },
    "payment_settings": {
        "get_a_quote": "Get a quote",
        "card_prices": "Card prices",
        "sign_up": "Sign up",
        "add_payment_method": "Enter payment data"
    },
    "archive": {
        "do": "Archive",
        "undo": "Unarchive",
        "load": "Load archive",
        "expense_search": "Search for specific expenses",
        "transaction_search": "Search for specific transactions"
    },
    "confirm": "Confirm",
    "sheet_template": "Sheet template",
    "bulk_data_upload": "Bulk data upload",
    "document": "Completed sheet",
    "upload": "Upload",
    "download": "Download",
    "upload_my_data": "Upload my data",
    "import_result_log": "Result log",
    "waiting": {
        "title": "Action in progress"
    },
    "transaction_category": {
        "create_inflow": "Create inflow category",
        "create_outflow": "Create outflow category",
        "new_inflow": "New inflow category",
        "new_outflow": "New outflow category",
        "edit": "Edit category",
        "title": {
            "create": "Add category",
            "edit": "Edit category"
        }
    },
    "integrations": {
        "get_my_invoices": {
            "set_up": "GetMyInvoices setup",
            "save": "Save"
        },
        "personio": {
            "connect": "Connect",
            "update": "Update",
            "manualSync": "Manually synchronize data",
            "save": "Save"
        }
    },
    "abort_setup": "Abort setup",
    "payment_method": {
        "save": "Save",
        "cancel": "Cancel"
    },
    "demo_url": "https://finway.de/en/upgrade-get-a-demo/",
    "create_recurring_expense": {
        "create": "Create a recurring expense",
        "submit": "Create"
    },
    "per_diem_summary": "Internal receipt per diem",
    "mileage_summary": "Internal receipt mileage",
    "accept_sepa_debit_agreement": "I accept the above-mentioned agreements of direct debit.",
    "issue_finway_card": "Issue finway card",
    "can_wait": "I can wait",
    "expense_tag": {
        "create": "Create tag",
        "add": "Add a tag"
    },
    "csv_settings_title": "Custom CSV Template",
    "validation_results": "Validation results",
    "choose_this_instead": "Choose this instead",
    "import_results": "Import results",
    "validate_data": "Validate data",
    "confirm_data_import": "Confirm data import",
    "approval_process": "Approval process",
    "folder_approval_process": "Folder approval process",
    "table": {
        "select_page": "Select only visible page",
        "select_all": "Select all pages"
    },
    "role_settings": {
        "create_custom_role": "Create a custom role",
        "edit_custom_role": "Edit a custom role"
    },
    "download_invoices": "Export invoices",
    "download_billable_invoices": "Only billable invoices",
    "trip_folder": {
        "create": "New trip folder",
        "edit": "Update trip folder",
        "submit": "Create folder",
        "save": "Save"
    },
    "sso": {
        "setup": "Setup",
        "update": "Update",

        "deforce": {
            "title": "Deforce SSO",
            "message": "This will enable email/password logins again"
        },
        "login_with_x": "Login with {{key}}"
    },
    "update_through_ocr_continue": "Continue",
    "regenerate_statement": "Regenerate statement",
    "re_authenticate": "Re-Authenticate",
    "reset_password_for_user": "Reset password for user",
    "unblock_user": "Unblock user",
    "sync": "Synchronize",
    "sessions_logout": "Log out of all active sessions",
    "save_and_continue_to_finway": "Save and continue to finway",
    "select": "Select",
    "deselect": "Deselect",
    "po_link": {
        "link_items": "Link items",
        "auto_link_all": "Auto-link all",
        "select_purchase_orders": "Select purchase orders",
        "clear_all": "Clear all",
        "submit_links": "Submit links",
        "unlink": "Unlink",
        "manage_links": "Manage links"
    },
    "view_document": "View document",
    "vendor_payments": {
        "download_avis": "Remittance advice",
        "confirm_and_pay": "Confirm & pay",
        "set_up": "Set up vendor payments",
        "cancel": "Cancel vendor payment"
    }
}
